import type { IStorageImplementation } from '../@types';
import { getErrorMessage } from '../utils/getErrorMessage';
import { getLogger } from '../utils/SearchLogger';

export default class SessionStorageImpl implements IStorageImplementation {
	clear(): void {
		globalThis.sessionStorage.clear();
	}
	// Executes the setItem
	setItem(key: string, value: Record<string, any>): void {
		try {
			// We JSON.stringify for you so that you don't have to
			globalThis.sessionStorage.setItem(key, JSON.stringify(value));
		} catch (e) {
			getLogger().error('Session Storage Utils', 'Error writing to Session Storage', getErrorMessage(e));
		}
	}

	// Executes the getItem
	getItem(key: string): Record<string, any> | null {
		let item: Record<string, any> | null = null;

		try {
			const sessionStorageItem = globalThis.sessionStorage.getItem(key);
			// We JSON.parse it for you so that you don't have to
			item = JSON.parse(sessionStorageItem);
		} catch (e) {
			getLogger().error('Session Storage Utils', 'Error reading from Session Storage', getErrorMessage(e));
		}

		return item;
	}

	// Executes the removeItem
	removeItem(key: string): void {
		globalThis.sessionStorage.removeItem(key);
	}
}
